export const SIDEBAR_SET = 'sidebar-set';
